import { NavBar } from "./Navbar";
import { Button, ButtonGroup } from "@mui/material";
import { useState } from "react";
import "./HowItWorks.css";

export function HowItWorks() {
  return (
    <div>
      <NavBar />
      
      <div style={{
        maxWidth: 800,
        margin: "auto",
        padding: "2rem",
        lineHeight: 1.5
      }}>
        <p>
          Makemybrand is a LinkedIn Carousel Generator. It helps you create high-engagement LinkedIn Carousel posts, in the form of PDF files. You can create LinkedIn Carousels in two ways:
            <ul>
                <li>From the makemybrand website, or </li>
                <li>From your LinkedIn home page, by installing our Chrome extension</li>
            </ul>
        </p>
        <p>
            <h2>How do you create a Carousel Post on LinkedIn?</h2>

            <p>
                <strong>Step 1:</strong> Choose a template from the makemybrand Chrome Extension or the Website.
            </p>
            <p>
                <strong>Step 2:</strong> Enter your text, or blog URL, or a topic.
            </p>
            <p>
                <strong>Step 3:</strong> Download the PDF.
            </p>
            <p>
                <strong>Step 4:</strong> Go to linkedin.com and create a post. Click on + button. Then click on "Add a document". Then click "Post".
            </p>
            <p>
                That's it! LinkedIn will automatically convert your PDF into a Carousel post.
            </p>
        
         
            <div style={{
                marginTop: "2rem"
            }}>
                <h2>I have downloaded the PDF. How do you upload it to LinkedIn?</h2>
                <p>See this video for a step by step guide on how to upload your PDF to LinkedIn:</p>
                <iframe style={{
                    marginTop: "1rem",
                }} width="560" height="315" src="https://www.youtube.com/embed/Vq1ZC3AbabY" title="How to create Linkedin Carousel posts" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>

            <div>
                <h2>Why post Carousels?</h2>
                <p>LinkedIn's algorithm promotes content that has</p>
                <p>- A high dwell time. This is how long a user spends reading your post. The longer, the better.</p>
                <p>- High engagement. Carousel posts have 3x more engagement than plain text posts.</p>
                <p>- Visual content. Carousels are visual, and therefore more engaging than plain text posts.</p>
                <br/>
                <p>Also, top 1% creators post more carousels than any other type of post.</p>
                <p>Are you looking to boost your LinkedIn marketing strategy? Then carousels are your secret sauce to getting more engagement.</p>
                <p>This begs the question. Why don't more people post them?</p>
                <p>Because they are difficult to create, since they are in the form of a PDF file. That's where makemybrand comes in.</p>
                <br/>
                <p><strong>MakeMyBrand's carousels</strong></p>
                <p>- use professional designed templates</p>
                <p>- have your brand embedded in the design: your picture, name, tagline and website</p>
                <p>- use proven hooks and state-of-the-art AI models to generate high-engagement text in each slide</p>
                <p>- take 2 minutes to create</p>
                <p>- simplify your content strategy by reusing existing content such as blog posts and LinkedIntext posts</p>
            </div>
            <br/>
            <p>In short, makemybrand's carousels are the easiest way to create high-engagement LinkedIn posts.</p>
            <Button
                variant="outlined"
                fullWidth

                style={{
                    marginTop: "1rem",
                    padding: "0.5rem 2rem",
                    fontSize: "1rem",
                    textTransform: "none",
                    color: "purple"
                }}
                onClick={() => {
                    window.location.href = "/";
                }}
            >Generate a Carousel Now</Button>
            <br/>

            <p style={{
                fontSize: "0.8rem",
                color: "gray"
            }}>Got questions? Contact us at support@makemybrand.ai and we'll get back to you right away.</p>
            <br/>
            <br/>
        </p>
        
      </div>
    </div>
  )
}